import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    list: {
      borderRadius: 8,
      display: 'flex',
      flexDirection: 'column',
      marginBottom: 32,
    },

    button: {
      width: 'min(calc(100% - 12px), 360px)',
      borderRadius: 8,
    },
    btnContainer: {
      display: 'flex',
      justifyContent: 'center',
    },
  },
  { name: 'LoadMore' },
);

export default useStyles;
